module.exports = __webpack_public_path__ + "img/main_image8.eb33573b.png";